// src/components/common/GlobalLoader.jsx
// -----------------------------------------------------------------------------
// Full-screen centered API loader overlay component.
// Reads loading visibility status from LoadingContext.
// -----------------------------------------------------------------------------
import { useLoading } from '../../context/LoadingContext';
import './common.css';

export default function GlobalLoader() {
  const { isLoading } = useLoading();

  if (!isLoading) return null;

  return (
    <div className="global-loader-overlay">
      <div className="global-loader-box">
        <div className="afix-loader-spinner" />
        <span className="global-loader-text">
          Processing request...
        </span>
      </div>
    </div>
  );
}
